import { render, staticRenderFns } from "./TableDeliveredInvoices.vue?vue&type=template&id=1f8f0d1f&scoped=true&"
import script from "./TableDeliveredInvoices.vue?vue&type=script&lang=js&"
export * from "./TableDeliveredInvoices.vue?vue&type=script&lang=js&"
import style0 from "./TableDeliveredInvoices.vue?vue&type=style&index=0&id=1f8f0d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f0d1f",
  null
  
)

export default component.exports